/**
 * Token + new password fields (recovery sheet body).
 * @see ../atomicRules.ts
 */
import { StyleSheet } from 'react-native';
import { appTheme } from '../../appTheme';
import type { ThemeColors } from '../../store';

export function createPasswordRecoveryFormSheetStyles(c: ThemeColors) {
  return StyleSheet.create({
    /** Intrinsic — % / flex:1 heights collapse inside center shrink-wrap panels. */
    keyboardView: { width: '100%', flexGrow: 0, flexShrink: 1 },
    scroll: { width: '100%', flexGrow: 0, flexShrink: 1 },
    scrollContent: {
      flexGrow: 0,
      paddingHorizontal: appTheme.spacing.lg,
      paddingTop: appTheme.spacing.sm,
      paddingBottom: appTheme.spacing.xxl,
      maxWidth: 440,
      width: '100%',
      alignSelf: 'center',
    },
    iconContainer: {
      width: 80,
      height: 80,
      borderRadius: 40,
      backgroundColor: c.primaryUltra,
      justifyContent: 'center',
      alignItems: 'center',
      alignSelf: 'center',
      marginTop: appTheme.spacing.xl,
      marginBottom: appTheme.spacing.lg,
    },
    title: {
      ...appTheme.typography.h2,
      color: c.text,
      textAlign: 'center',
      marginBottom: appTheme.spacing.sm,
    },
    subtitle: {
      ...appTheme.typography.bodySmall,
      color: c.textSecondary,
      textAlign: 'center',
      marginBottom: appTheme.spacing.xl,
      lineHeight: 20,
    },
    formGroup: {
      marginBottom: appTheme.spacing.md,
    },
    errorText: {
      ...appTheme.typography.caption,
      color: c.error,
      marginBottom: appTheme.spacing.md,
    },
    scrollBottomSpacer: {
      height: 40,
    },
  });
}

export type PasswordRecoveryFormSheetStyles = ReturnType<typeof createPasswordRecoveryFormSheetStyles>;
